/* pbn-ui.js — facelift behaviour (facelift/TOTEUTUS.md). Loaded with defer only when a facelift area is on.
   DOM events (Booster's own booster:* events included), IntersectionObserver and fetch; Booster's global binding is
   read only as a fallback (cart data, "is Booster there"). Every part is independent. */
(function () {
  'use strict';
  var d = document, B = d.body;
  var EN = (d.documentElement.lang || 'fi').toLowerCase().indexOf('fi') !== 0;
  // a third language (Swedish pilot B1): TX(key, the fi/en text) gives its own text when the theme printed one
  var OWN_TX;
  function TX(key, fallback) {
    if (OWN_TX === undefined) {
      try {
        var el = d.querySelector('script[data-sampo-js-texts="ui"]');
        OWN_TX = el ? JSON.parse(el.textContent || 'null') : null;
      } catch (error) {
        OWN_TX = null;
      }
    }
    return OWN_TX && typeof OWN_TX[key] === 'string' && OWN_TX[key] ? OWN_TX[key] : fallback;
  }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function part(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[pbn-ui] ' + name, e); } }
  // GA4 event like nav_click (sampo-nav.js) and faq_open: only when the theme's gtag is there (consent), never blocks
  // the click (owner 30.9.2026: sticky_buy and cart_offer_add; not Shopify.analytics.publish)
  function track(name, category, label) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, { event_category: category, event_label: label, transport_type: 'beacon' }); } catch (e) { /* ignore */ }
  }
  function fmtSize(v) {
    var m = String(v || '').replace(/×/g, 'x').match(/(\d{2,3})\s*x\s*(\d{2,3})\s*cm/i);
    // a third language (Swedish pilot B1, style guide 4.5): number ranges with an en dash (1–35)
    if (!m && TX('display', '') === 'on') return String(v || '').replace(/^\s*(\d+)\s*-\s*(\d+)\s*$/, '$1–$2');
    return m ? m[1] + ' × ' + m[2] + ' cm' : String(v || '');
  }
  function onVariantChange(cb) {
    // Booster writes the chosen variant to input[name="id"]; swatch clicks and selects cover the rest
    var input = $('.product__page--info input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
    if (input && 'MutationObserver' in window) new MutationObserver(cb).observe(input, { attributes: true, attributeFilter: ['value'] });
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-swatch-option]')) setTimeout(cb, 90); });
    d.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('select, [name="id"], .pbn-framing-selector input')) setTimeout(cb, 0); });
  }

  function init() {
    /* ---- product area: sticky buy bar (mobile) ----
       Shown only once the page's own buy block has been scrolled past upwards: a block that is still below the fold at
       load does not bring the bar up over the title and price (audit V1-02, 30.9.2026). The small line lists every
       active choice (custom DP: shape and size) but not a gift card's value, which the price already shows (T1-05).
       The bar's button follows the page's own button: a sold-out variant disables it with the same text (T1-06). On a
       custom page a click on "Upload photo" never adds to the cart, also when the photo got ready meanwhile (T1-07).
       Custom pages before the photo is stored (owner 3.11.2026, an exception to V1-02 for these pages only): "Upload
       photo" shows from the start whenever the choices (the option steps and the photo upload) are out of view, above
       or below, and hides while any of them is in view; a tap scrolls to the first choice (PBN size, DP drill shape),
       so every step is seen in order. With the photo stored the bar works as on the other pages. Phones only: the
       bar is display:none from 768 px (pbn-ui.css). */
    if (B.classList.contains('pbn-fl-product')) part('sticky', function () {
      var bar = $('[data-pbn-sticky]'); if (!bar) return;
      var atc = bar.closest('.product__atc') || $('.product__page--info .product__atc'); if (!atc) return;
      var realBtn = $('[data-buy-button]', atc) || $('button[type="submit"]', atc);
      B.appendChild(bar); // fixed positioning must not depend on the product column's styles
      var nameEl = $('[data-pbn-sticky-name]', bar), priceEl = $('[data-pbn-sticky-price]', bar);
      var baseName = nameEl.getAttribute('data-name') || nameEl.textContent;
      var barBtn = $('[data-pbn-sticky-buy]', bar), uploadMode = bar.getAttribute('data-mode') === 'upload';
      function paint() {
        var total = $('[data-framing-total]:not([hidden]) [data-framing-total-value]');
        // kampanjamoottori 20261028a: the first price the customer sees; a campaign row or its normal-price twin that
        // the campaign guard hides (an ancestor with data-sc-to and display:none) is skipped
        var price = null;
        $$('.product__page--info .product__price').some(function (p) {
          var w = p.closest('[data-sc-to]');
          if (w && w.style.display === 'none') return false;
          price = p;
          return true;
        });
        var ptxt = total ? total.textContent : (price ? price.textContent : priceEl.textContent);
        priceEl.textContent = String(ptxt || '').replace(/\s+/g, ' ').trim();
        var bits = [], seen = {};
        $$('.product__page--info .product__swatches .swatch--active').forEach(function (sw) {
          var v = sw.getAttribute('data-swatch-option') || '', k = sw.getAttribute('data-swatch-index') || v;
          if (!v || seen[k]) return; // one per option
          seen[k] = 1;
          if (/^\s*[€$£]|[€$£]\s*$/.test(v)) return; // a money value (gift card): the price shows it
          bits.push(fmtSize(v));
        });
        var ch = $('.pbn-framing-choice.is-selected');
        if (ch && ch.getAttribute('data-framing-choice') === 'diy') bits.push(TX('woodenFrame', EN ? 'Wooden frame' : 'Puinen kehys'));
        if (ch && ch.getAttribute('data-framing-choice') === 'service') bits.push(TX('preStretched', EN ? 'Pre-stretched' : 'Valmiiksi pingotettu'));
        bits.push(baseName);
        nameEl.textContent = bits.join(' · ');
      }
      paint();
      onVariantChange(paint);
      // the campaign guard (snippets/sampo-campaign) checks the window at load, at its end, on waking up and from
      // the back-forward cache, and after Booster's variant prices: paint again each time (kampanjamoottori 20261028a)
      d.addEventListener('sampo:campaign:check', paint);
      d.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.pbn-framing-selector')) setTimeout(paint, 0); });
      // custom pages: the option steps and the photo upload, in page order
      function choices() {
        var list = $$('.product__page--info .product__swatches');
        var up = $('#pbn-upload-root') || $('.pbn-upload-container');
        if (up) list.push(up);
        return list;
      }
      function shown(list) { return list.filter(function (el) { return el.getClientRects().length > 0; }); }
      function headerH() {
        var hd = shown($$('.page__header'))[0] || $('[id^="shopify-section-header"]');
        return hd ? Math.min(hd.offsetHeight, 120) : 0;
      }
      // custom pages: "Upload photo" until the upload widget has stored the photo, then the normal add to cart
      function photoReady() {
        var img = $('.product__page--info input[name="properties[_uploaded_image]"]') || $('input[name="properties[_uploaded_image]"]');
        return !!(img && img.value);
      }
      function label() {
        if (realBtn && realBtn.disabled) { // Booster: sold-out variant = its own text ("Loppuunmyyty") and disabled
          var t = $('[data-button-text]', realBtn) || realBtn;
          barBtn.disabled = true;
          barBtn.textContent = String(t.textContent || '').replace(/\s+/g, ' ').trim() || TX('soldOut', EN ? 'Sold out' : 'Loppuunmyyty');
          return;
        }
        barBtn.disabled = false;
        var ready = !uploadMode || photoReady();
        if (uploadMode) bar.setAttribute('data-mode', ready ? 'buy' : 'upload');
        barBtn.textContent = ready ? TX('addToCart', EN ? 'Add to cart' : 'Lisää ostoskoriin') : TX('uploadPhoto', EN ? 'Upload photo' : 'Lataa kuva');
      }
      label();
      var refresh = function () { label(); }; // show() replaces this once the observers below are set up
      // the page's own button changes: variant sold out or back (disabled, text), photo stored (the upload widget's flag)
      if (realBtn && 'MutationObserver' in window) new MutationObserver(function () { refresh(); }).observe(realBtn, { attributes: true, attributeFilter: ['disabled', 'data-pbn-blocked'], childList: true, characterData: true, subtree: true });
      barBtn.addEventListener('click', function () {
        var wasUpload = bar.getAttribute('data-mode') === 'upload';
        label();
        if (barBtn.disabled) return;
        if (wasUpload) { // the button said "Upload photo": no photo yet -> to the choices; photo ready -> it now says "Add to cart"
          if (bar.getAttribute('data-mode') === 'upload') {
            var first = shown(choices().filter(function (el) { return el.classList.contains('product__swatches'); }))[0];
            var step = first && ($('.swatches__holder', first) || first);
            if (step) {
              // the step's heading lands just under the header, which is fixed on phones once the page has scrolled;
              // keyboard and screen reader focus moves there too (the bar hides once the step is in view)
              var title = $('.swatches__title', step) || step;
              if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
              try { title.focus({ preventScroll: true }); } catch (e) { /* old browser: focus stays */ }
              var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              window.scrollTo({ top: Math.max(0, step.getBoundingClientRect().top + window.pageYOffset - headerH() - 12), behavior: still ? 'auto' : 'smooth' });
            } else {
              var up = $('#pbn-upload-root') || $('.pbn-upload-container') || $('.product__page--info [id*="upload"]');
              (up || atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return;
        }
        if (!realBtn) return;
        track('sticky_buy', uploadMode ? 'custom' : 'stock', location.pathname); // buy mode only (upload mode returned above)
        realBtn.click(); // the page's own button: frame pairing and photo checks run as before
      });
      if (!('IntersectionObserver' in window)) return;
      // passed = the buy block is above the window's top edge. The observer's root reaches far below the window, so the
      // block leaves it only upwards, also when the page jumps past the block at once (anchor link, restored scroll
      // position: nothing crosses the window then; F-5 test 30.9.2026)
      var passed = false;
      // custom pages: the choices = the option steps (every copy of the swatch block; a hidden copy never intersects)
      // and the photo upload; seen = how many of them are on the screen now (null = not known yet)
      var upBlock = $('#pbn-upload-root') || $('.pbn-upload-container');
      var picks = uploadMode && upBlock ? choices() : [], seen = null, inView = [];
      function show() {
        label();
        var early = uploadMode && picks.length && seen !== null && !photoReady();
        var on = early ? seen === 0 : passed;
        bar.classList.toggle('is-on', on);
        B.classList.toggle('pbn-sticky-on', on);
      }
      refresh = show;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { passed = !e.isIntersecting; });
        show();
      }, { rootMargin: '0px 0px 200000px 0px' }).observe(atc);
      if (picks.length) {
        // "on the screen" = under the header and above the lowest 30 % of the window height (pixels: a % rootMargin
        // is not resolved the same way everywhere): a step that only peeks in at the bottom edge (the first view of a
        // tall phone) does not count, so the bar is there from the start. Made again when the window size changes.
        var io = null, sizeTimer = 0, lastH = 0;
        var watch = function () {
          var h = window.innerHeight;
          if (io && Math.abs(h - lastH) < 80) return; // the toolbar of a mobile browser sliding in or out
          lastH = h;
          if (io) io.disconnect();
          inView = [];
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var i = picks.indexOf(e.target);
              if (i >= 0) inView[i] = e.isIntersecting;
            });
            seen = inView.filter(Boolean).length;
            show();
          }, { rootMargin: '-' + headerH() + 'px 0px -' + Math.round(h * 0.3) + 'px 0px' });
          picks.forEach(function (el) { io.observe(el); });
        };
        watch();
        window.addEventListener('resize', function () { clearTimeout(sizeTimer); sizeTimer = setTimeout(watch, 200); }, { passive: true });
      }
    });

    /* ---- product area, desktop: the gallery frame follows the picture on view, smoothly ----
       The stylesheet alone keeps the frame as tall as the picture Booster calls current (data-bstr-slider-current),
       but Booster writes that only after the slide's scroll has ended, and a change of an "auto" height cannot be
       animated. So the height is held in --pbn-gal-h (animated by the stylesheet) for the time of the change only:
       set at once on a thumbnail or arrow click and when Booster's own value changes (swipe, variant picture), and
       removed when the frame has reached the current picture. At rest the stylesheet rules, so the frame follows the
       window size without script. Phones are left alone (the theme's 50vh frame). */
    if (B.classList.contains('pbn-fl-product')) part('gallery', function () {
      var holder = $('.gallery__default .slider--product-holder'); if (!holder || !('MutationObserver' in window)) return;
      var gallery = holder.closest('.gallery__default'), wide = window.matchMedia('(min-width: 768px)'), VAR = '--pbn-gal-h';
      var rest = 0, timer = 0; // rest = the frame's height at rest: after Booster's value has changed only the new one can be measured
      function current() { var n = parseInt(holder.getAttribute('data-bstr-slider-current'), 10); return n > 0 ? n : 0; }
      function frame() { return holder.getBoundingClientRect().height; }
      function held() { return !!holder.style.getPropertyValue(VAR); }
      function heightOf(i) {
        var s = $$('.slide--product', holder)[i];
        var el = s && ($('img:not(.zoomImg), video, iframe, model-viewer', s) || s.firstElementChild);
        return el ? el.getBoundingClientRect().height : 0;
      }
      function fit(i, from) { // true when the frame started to change its height
        if (!wide.matches) return false;
        var to = heightOf(i); if (!(to > 0)) return false;
        if (held()) from = frame();
        if (!(from > 0) || Math.abs(from - to) < 1) return false;
        holder.style.setProperty(VAR, from + 'px'); // start from the height on screen
        void holder.offsetHeight;
        holder.style.setProperty(VAR, to + 'px');
        clearTimeout(timer); timer = setTimeout(settle, 450); // when no transitionend comes (reduced motion)
        return true;
      }
      function settle() { // the frame has reached Booster's current picture: the height goes back to the stylesheet
        if (!held()) { rest = frame(); return; }
        var h = heightOf(current());
        if (!(h > 0) || Math.abs(frame() - h) >= 1) return; // still on its way, or Booster has not caught up yet
        holder.style.removeProperty(VAR);
        if (Math.abs(frame() - h) >= 1) holder.style.setProperty(VAR, h + 'px'); // a slide the stylesheet does not list (21st on)
        rest = h;
      }
      rest = frame();
      var guard = 0; // until then a click on the picture is not meant for it (see below)
      gallery.addEventListener('click', function (e) { // capture: Booster stops the arrows' click from bubbling
        var t = e.target.closest && e.target.closest('[data-bstr-slider-thumb], [data-bstr-slider-button]'); if (!t) return;
        var last = $$('.slide--product', holder).length - 1, i;
        if (t.hasAttribute('data-bstr-slider-thumb')) i = parseInt(t.getAttribute('data-bstr-slider-thumb'), 10);
        else i = current() + (t.getAttribute('data-bstr-slider-button') === '-' ? -1 : 1);
        if (last >= 0 && i === i && fit(Math.max(0, Math.min(last, i)), frame())) guard = Date.now() + 450;
      }, true);
      // The thumbnail row moves with the frame. The second click of a double click on a thumbnail, or a click made
      // while the row is still moving, lands on the picture that has come under the pointer: it must not open the
      // lightbox or the diamond zoom by accident. On the document, so it runs before the zoom's own capture listener
      // on the gallery column. The zoom's chip button always works.
      d.addEventListener('click', function (e) {
        if (Date.now() < guard && e.target && holder.contains(e.target) && !(e.target.closest && e.target.closest('.sampo-dpz-open'))) { e.stopPropagation(); e.preventDefault(); }
      }, true);
      new MutationObserver(function () { fit(current(), rest || frame()); settle(); })
        .observe(holder, { attributes: true, attributeFilter: ['data-bstr-slider-current'] });
      holder.addEventListener('transitionend', function (e) { if (e.target === holder && e.propertyName === 'height') settle(); });
      window.addEventListener('resize', function () { holder.style.removeProperty(VAR); rest = 0; }, { passive: true });
    });

    /* ---- product area: description ~8 lines + "read more" on mobile, cut between blocks ---- */
    if (B.classList.contains('pbn-fl-product') && window.matchMedia('(max-width: 767px)').matches) part('clamp', function () {
      $$('.product__page--info .product__description').forEach(function (desc) {
        if (desc.scrollHeight <= 300) return;
        var box = $(':scope > div', desc) || desc;
        while (box.children.length === 1 && box.firstElementChild.children.length > 1) box = box.firstElementChild;
        var blocks = Array.prototype.slice.call(box.children), top = box.getBoundingClientRect().top, keep = 0, hasText = false;
        for (var i = 0; i < blocks.length; i++) {
          var bottom = blocks[i].getBoundingClientRect().bottom - top;
          if (hasText && bottom > 240) break;
          keep = i + 1;
          if (blocks[i].textContent.trim()) hasText = true;
        }
        while (keep > 1 && /^H[1-6]$/.test(blocks[keep - 1].tagName)) keep--; // never end on a heading
        var rest = blocks.slice(keep); if (!rest.length) return;
        rest.forEach(function (x) { x.classList.add('pbn-hide'); });
        var more = d.createElement('button');
        more.type = 'button'; more.className = 'pbn-more'; more.setAttribute('aria-expanded', 'false');
        more.textContent = TX('readMore', EN ? 'Read more' : 'Lue lisää');
        more.addEventListener('click', function () {
          var open = more.getAttribute('aria-expanded') === 'true';
          rest.forEach(function (x) { x.classList.toggle('pbn-hide', open); });
          more.setAttribute('aria-expanded', String(!open));
          more.textContent = open ? TX('readMore', EN ? 'Read more' : 'Lue lisää') : TX('showLess', EN ? 'Show less' : 'Näytä vähemmän');
        });
        desc.appendChild(more); // inside the description: stays with it when the custom area moves it (CSS order)
      });
    });

    /* ---- cart area: delivery line, one offer, bundle line, payment icons in Booster's mini-cart ----
       The parts (sections/pbn-cart-extras) are fetched only while the drawer is open, and again only when the cart's
       content has changed (key = rows + quantities + total from Booster's booster:cart:update event), never on a plain
       page load (audit TK-8, SUO-R7). An answer for an older cart state is dropped. Booster redraws the drawer on every
       change, so the parts are placed again after each redraw, from memory while the key is the same. */
    if (B.classList.contains('pbn-fl-cart')) part('cart', function () {
      var holders = $$('.minicart__holder'); if (!holders.length) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cartKey = null, cache = { key: null, html: null }, seq = 0, busy = null;
      var addError = null; // failed "+ Lisää": { id, text }, shown again after Booster's redraw until the cart changes
      function keyOf(data) {
        if (!data || data.item_count == null) return null;
        var items = data.items || {}, rows = [];
        Object.keys(items).forEach(function (k) { rows.push(k + '*' + (items[k] && items[k].quantity)); });
        return data.item_count + '|' + data.total_raw + '|' + rows.sort().join(',');
      }
      function currentKey() {
        if (cartKey === null) { // our listener missed Booster's first event: read the same data once
          try { cartKey = keyOf(BoosterTheme.cart.minicart.data); } catch (e) { /* unknown until the next change */ }
        }
        return cartKey || 'n/a';
      }
      function isOpen() { return d.documentElement.classList.contains('bstr-minicart-open'); }
      function needed() { return holders.some(function (h) { return $('.minicart__entry', h) && !$('[data-pbn-cx-in]', h); }); }
      function put(html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var top = $('[data-pbn-cx-top]', tmp), after = $('[data-pbn-cx-after]', tmp), bottom = $('[data-pbn-cx-bottom]', tmp);
        holders.forEach(function (h) {
          var entries = $('.minicart__entries', h), bot = $('.minicart__bottom', h);
          if (!entries || !$('.minicart__entry', h) || $('[data-pbn-cx-in]', h)) return;
          function add(node, where, ref) { if (!node || !node.innerHTML.trim()) return; var c = node.cloneNode(true); c.setAttribute('data-pbn-cx-in', ''); where === 'after' ? ref.parentNode.insertBefore(c, ref.nextSibling) : ref.appendChild(c); }
          var title = $('.minicart__title', entries);
          if (title) add(top, 'after', title); else add(top, 'append', entries);
          add(after, 'append', entries);
          if (!bot) return;
          // the Bundle discount line goes above the total it is part of, not under the checkout button (T1-09);
          // customs note and payment icons stay at the end
          var total = $('.minicart__total', bot), rest = bottom;
          if (total && bottom && $('.pbn-sum', bottom)) {
            var sums = d.createElement('div'); sums.className = 'pbn-cartx pbn-cx-sums'; sums.setAttribute('data-pbn-cx-in', '');
            $$('.pbn-sum', bottom).forEach(function (x) { sums.appendChild(x.cloneNode(true)); });
            total.parentNode.insertBefore(sums, total);
            rest = bottom.cloneNode(true);
            $$('.pbn-sum', rest).forEach(function (x) { x.parentNode.removeChild(x); });
          }
          add(rest, 'append', bot);
        });
        showError(false);
      }
      function showError(announce) {
        if (!addError) return;
        $$('[data-pbn-add="' + addError.id + '"]').forEach(function (b) {
          var offer = b.closest('.pbn-offer') || b.parentNode;
          if ($('.pbn-offer__err', offer)) return;
          var p = d.createElement('p'); p.className = 'pbn-offer__err';
          if (announce) p.setAttribute('role', 'alert'); // announced once, not again on every redraw
          p.textContent = addError.text; offer.appendChild(p);
        });
      }
      function place(opening) {
        if (!needed()) return;
        var key = currentKey();
        if (cache.key === key && cache.html !== null) { put(cache.html); return; }
        if (!opening && !isOpen()) return; // closed drawer: nothing is fetched
        if (busy === key) return; // this cart state is already on its way
        var my = ++seq; busy = key;
        fetch(root + '?sections=pbn-cart-extras', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('extras ' + r.status); return r.json(); })
          .then(function (j) {
            if (my !== seq) return; // a newer request is on its way: this answer is older
            busy = null;
            if (key !== currentKey()) { place(); return; } // the cart changed meanwhile: dropped, asked again if open
            cache.key = key; cache.html = j['pbn-cart-extras'] || '';
            put(cache.html);
          }).catch(function () { if (my === seq) busy = null; /* the drawer works without the extras */ });
      }
      d.addEventListener('booster:cart:update', function (e) {
        var k = keyOf(e.detail && e.detail.data);
        if (k !== null) { if (cartKey !== null && k !== cartKey) addError = null; cartKey = k; }
      });
      d.addEventListener('booster:minicart:state', function (e) { if (e.detail && e.detail.open) place(true); });
      d.addEventListener('booster:content:update', function (e) { if (!e.detail || !e.detail.trigger || e.detail.trigger === 'minicart') place(); });
      var timer = 0; // other redraws of the drawer
      var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(place, 60); });
      holders.forEach(function (h) { mo.observe(h, { childList: true, subtree: true }); });
      place();
      // Booster's fetch hook redraws the drawer after every <root>cart/add.js answer (booster.js bindXHRFetch); Booster
      // keeps its cart object as a global binding, not on window. Without Booster the page is reloaded.
      function boosterRedraws() { try { return typeof BoosterTheme !== 'undefined' && !!(BoosterTheme && BoosterTheme.cart); } catch (e) { return false; } }
      d.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-pbn-add]'); if (!btn) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true; btn.setAttribute('aria-busy', 'true');
        addError = null;
        $$('.pbn-offer__err').forEach(function (x) { x.parentNode.removeChild(x); });
        var id = btn.getAttribute('data-pbn-add'), label = btn.getAttribute('data-pbn-offer') || 'offer';
        var qty = parseInt(btn.getAttribute('data-pbn-qty'), 10); // three frames per Mystery Box (owner 29.10.2026)
        var item = { id: Number(id), quantity: qty > 0 ? qty : 1 }, printTitle = btn.getAttribute('data-pbn-title');
        if (printTitle) item.properties = { _PRINT_TITLE: printTitle }; // like every other add path of the theme (T1-08)
        fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          track('cart_offer_add', 'minicart', label);
          // the product page's own add-on toggles (pbn-accessory, dp-upsell, pbn-upsell) re-read the cart on this event,
          // so a drawer add shows there as "Korissa" and is not added a second time (audit 14.10.2026)
          d.dispatchEvent(new CustomEvent('cart:updated'));
          if (!boosterRedraws()) location.reload();
        }).catch(function () {
          btn.disabled = false; btn.removeAttribute('aria-busy');
          addError = { id: id, text: TX('addError', EN ? 'Adding to the cart did not work. Please try again.' : 'Lisääminen ostoskoriin ei onnistunut. Yritä uudelleen.') };
          showError(true);
        });
      });
      // the "second painting" hint has no add button: its link click is the offer's use (event_label toinen_maalaus)
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[data-pbn-offer]');
        if (a) track('cart_offer_add', 'minicart', a.getAttribute('data-pbn-offer'));
      }, true);
    });

    /* ---- collection pages from 1024 px: the filter column is pinned only when it fits the window ----
       sampo-catalog.css pins it (top 96 px) with its own scroll when it is taller than the window; on the root pages the
       groups under the window's edge were never seen (audit V3-03, 30.9.2026). A column that does not fit scrolls with
       the page instead (.pbn-drawer-free, pbn-ui.css). Checked when the page is ready and when the window size changes,
       not while the visitor opens groups (a pinned column then keeps its own scroll, as before). */
    if (B.classList.contains('pbn-fl-collection')) part('drawer', function () {
      var dr = $('[data-sampo-drawer]'); if (!dr || !window.matchMedia) return;
      var wide = window.matchMedia('(min-width: 1024px)'), timer = 0;
      function fit() {
        if (!wide.matches) { dr.classList.remove('pbn-drawer-free'); return; }
        dr.classList.add('pbn-drawer-free'); // measured at full length
        if (dr.scrollHeight <= window.innerHeight - 110) dr.classList.remove('pbn-drawer-free'); // the pinned column's max-height
      }
      fit();
      window.addEventListener('load', fit);
      window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(fit, 150); }, { passive: true });
    });

    /* ---- frame product: "fits a 30 × 40 cm painting" follows the chosen size ----
       The swatch block renders twice (the hidden mobile sticky bar first, then the product form), so every line is
       updated, not only the first one (owner 22.10.2026: the visible line stayed at the first size). */
    part('fit', function () {
      var fits = $$('[data-pbn-fit] b'); if (!fits.length) return;
      onVariantChange(function () {
        var a = $('.product__page--info .product__swatches .swatch--active');
        if (!a) return;
        var size = fmtSize(a.getAttribute('data-swatch-option'));
        fits.forEach(function (b) { b.textContent = size; });
      });
    });

    /* ---- search panel by keyboard (audit UX-02, 2.10.2026) ----
       Booster's panel closed only from the X or the overlay. Escape closes it, focus leaving it (Tab past the last
       result) closes it, and focus returns to the search icon that opened it. The closed panel is not focusable
       (visibility, pbn-ui.css). */
    part('search', function () {
      var box = $('[data-search-container]'); if (!box) return;
      var opener = null;
      d.addEventListener('click', function (e) {
        var ic = e.target.closest && e.target.closest('.search__icon');
        if (ic) opener = ic;
      }, true);
      function close(focusBack) {
        if (!box.classList.contains('focused')) return;
        box.classList.remove('focused');
        if (focusBack && opener && opener.isConnected && opener.offsetParent !== null) opener.focus();
        else if (box.contains(d.activeElement)) d.activeElement.blur();
      }
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && box.classList.contains('focused')) { e.preventDefault(); close(true); }
      });
      d.addEventListener('focusin', function (e) {
        if (box.classList.contains('focused') && !box.contains(e.target) && e.target !== opener) close(false);
      });

      /* phones (owner 7.10.2026): iOS does not shorten the fixed panel for the keyboard, so the results behind it could
         not be reached or scrolled. While the field is being typed in, the panel is as tall as the visible area above
         the keyboard (the results scroll inside it); a drag in the results lowers the keyboard to show the whole list.
         The height limit goes the moment the field loses focus: iOS reports the new height only after the keyboard
         has slid away, and meanwhile the page showed through below the panel (owner's video 7.10.2026). */
      var vv = window.visualViewport;
      var results = box.querySelector('[data-search-suggest]');
      var field = box.querySelector('input[data-search]');
      function fit(e) {
        var open = vv && box.classList.contains('focused');
        if (open && field && d.activeElement === field && !(e && e.type === 'blur')) box.style.maxHeight = Math.round(vv.height) + 'px';
        else box.style.removeProperty('max-height');
        if (open) box.style.top = Math.round(vv.offsetTop) + 'px';
        else box.style.removeProperty('top');
      }
      if (vv && field) {
        field.addEventListener('focus', fit);
        field.addEventListener('blur', fit);
      }
      if (vv) {
        vv.addEventListener('resize', fit);
        vv.addEventListener('scroll', fit);
        new MutationObserver(fit).observe(box, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('pageshow', fit); // back / forward cache: the keyboard may be down now
      }
      if (results && field) {
        var y0 = null;
        results.addEventListener('touchstart', function (e) { y0 = e.touches.length === 1 ? e.touches[0].clientY : null; }, { passive: true });
        results.addEventListener('touchmove', function (e) {
          if (y0 !== null && e.touches.length === 1 && Math.abs(e.touches[0].clientY - y0) > 8 && d.activeElement === field) {
            field.blur();
            y0 = null;
          }
        }, { passive: true });
      }
    });

    /* ---- option swatches by keyboard (audit UX-01, 2.10.2026) ----
       Booster's size and drill-shape swatches are click-only spans. Each option row becomes a radio group: Tab reaches
       the chosen option, arrow keys move and choose, Enter/Space choose; checked and sold-out states are announced.
       Booster's own click handler still does the choosing (o.click()). */
    part('swatch-keys', function () {
      var groups = $$('.swatches__holder').filter(function (h) { return $('span[data-swatch-option]', h); });
      if (!groups.length) return;
      function opts(h) { return $$('span[data-swatch-option]', h); }
      function sync() {
        groups.forEach(function (h) {
          var list = opts(h), active = null;
          list.forEach(function (o) {
            var on = o.classList.contains('swatch--active');
            if (on) active = o;
            o.setAttribute('aria-checked', on ? 'true' : 'false');
            if (o.classList.contains('swatch--disabled') || o.hasAttribute('data-swatch-soldout')) o.setAttribute('aria-disabled', 'true');
            else o.removeAttribute('aria-disabled');
          });
          list.forEach(function (o) { o.tabIndex = o === (active || list[0]) ? 0 : -1; });
        });
      }
      groups.forEach(function (h, gi) {
        var title = $('.swatches__title', h);
        h.setAttribute('role', 'radiogroup');
        if (title) { if (!title.id) title.id = 'pbn-swatch-title-' + gi; h.setAttribute('aria-labelledby', title.id); }
        opts(h).forEach(function (o) {
          o.setAttribute('role', 'radio');
          if (!o.textContent.trim()) o.setAttribute('aria-label', o.getAttribute('data-swatch-option'));
        });
        h.addEventListener('keydown', function (e) {
          var o = e.target.closest && e.target.closest('span[data-swatch-option]'); if (!o) return;
          var list = opts(h), i = list.indexOf(o), k = e.key, n = -1;
          if (k === 'Enter' || k === ' ') { e.preventDefault(); o.click(); return; }
          if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % list.length;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + list.length) % list.length;
          else if (k === 'Home') n = 0;
          else if (k === 'End') n = list.length - 1;
          if (n < 0) return;
          e.preventDefault();
          list[n].focus();
          list[n].click();
        });
      });
      sync();
      onVariantChange(sync);
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
